import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { oidcConfig } from 'common/config';
import AccountSelection from './AccountSelection';
import { actionCreators } from './store';

class AccountSelectionContainer extends React.Component {
  componentDidMount = () => {
    const { accounts } = this.props;
    if (accounts === null || accounts.length === 0) {
      this.props.getLinkedAccounts();
    }
  };

  handleAccountClick = (adfitNo) => {
    this.props.history.push(`/CustomerDetails/${adfitNo}`);
  };

  handleAddAccount = () => {
    // this.props.history.push('/AddAccount');
    const redirectUrl =
      oidcConfig.post_logout_redirect_uri + '/AddAccountRedirect';
    window.open(
      oidcConfig.authority + `/account/addaccount?returnUrl=${redirectUrl}`,
      '_blank'
    );
  };

  render() {
    const { accounts, localisation, location } = this.props;
    const showAccountAdded = location.state && location.state.accountAdded;
    return (
      <AccountSelection
        accounts={accounts}
        dateFormat={localisation.locales.dateFormat}
        onAccountClick={this.handleAccountClick}
        showAccountAdded={showAccountAdded}
        onAddAccountClick={this.handleAddAccount}
      />
    );
  }
}

AccountSelectionContainer.propTypes = {
  accounts: PropTypes.array,
};

export default compose(
  withRouter,
  connect(
    (state) => ({
      accounts: state.accountSelection.accounts,
      localisation: state.localisation,
      userFullName: state.auth.fullName,
    }),
    {
      getLinkedAccounts: actionCreators.getLinkedAccounts,
    }
  )
)(AccountSelectionContainer);
